export const HANDLE_LOADING = 'HANDLE_LOADING';
export const GET_USERS = 'GET_USERS';